module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/our_services_2-3e42cbf4c80b47fcf33b47d833bdf42b.jpg";